import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocAlertIssueSyncingRoute: InvariantJiraRoute = {
	name: 'eoc-alert-issue-syncing',
	path: '/jira/settings/products/ops/syncs',
	exact: true,
};
